import { isFiniteNumber } from "./is-finite-number";

type FindClosestNumbersOutput = [min: number, max: number];

export const findClosestNumbers = (value: number, ...nums: number[]): FindClosestNumbersOutput => {
  if (!isFiniteNumber(value) || !nums.length) return [NaN, NaN];

  const below: number[] = [];
  const above: number[] = [];

  for (let i = 0; i < nums.length; i++) {
    const num = nums[i];

    if (!isFiniteNumber(num)) return [NaN, NaN];
    if (num === value) return [value, value];

    if (num < value) below.push(num);
    if (num > value) above.push(num);
  }

  const min = Math.max(...below);
  const max = Math.min(...above);

  return [isFiniteNumber(min) ? min : max, isFiniteNumber(max) ? max : min];
};
